<dx-pie-chart [pathModified]="true"
              type="donut"
              [innerRadius]="0.66"
              [customizePoint]="customizeRatingsGraphPoint"
              [dataSource]="catchupRatings">
    <dxo-pie-chart-size [height]="215"></dxo-pie-chart-size>
    <dxi-pie-chart-series argumentField="label"
                          valueField="count"
                          name="Rating"></dxi-pie-chart-series>
    <dxo-pie-chart-tooltip [enabled]="true"
                           [customizeTooltip]="customizeTooltip"
                           [paddingLeftRight]="8"
                           [paddingTopBottom]="8"
                           color="black">
        <dxo-pie-chart-font color="white"
                            [weight]="500"></dxo-pie-chart-font>
        <dxo-pie-chart-border [visible]="false"></dxo-pie-chart-border>
    </dxo-pie-chart-tooltip>
    <dxo-pie-chart-legend horizontalAlignment="center"
                          verticalAlignment="bottom"
                          itemTextPosition="right"
                          [customizeText]="customizeRatingsGraphLegend"
                          [paddingLeftRight]="4"></dxo-pie-chart-legend>
</dx-pie-chart>
